export default __webpack_public_path__ + "static/media/Product_Sheet.4b24c033.xlsx";